"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MVT = _interopRequireDefault(require("ol/format/MVT"));

var _VectorTile = _interopRequireDefault(require("ol/layer/VectorTile"));

var _VectorTile2 = _interopRequireDefault(require("ol/source/VectorTile"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _propTypes = require("prop-types");

var VectorTileLayer = (0, _createLayer["default"])({
  displayName: 'VectorTileLayer',
  propTypes: {
    layerStyle: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object, _propTypes.func]),
    source: _propTypes.object,
    url: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string])
  },
  componentDidMount: function componentDidMount() {
    this.format = new _MVT["default"]();
    this.layer = new _VectorTile["default"]({
      style: this.props.layerStyle,
      source: new _VectorTile2["default"](Object.assign({
        format: this.format,
        url: this.props.url
      }, this.props.source))
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (!(0, _lodash["default"])(this.props.source, prevProps.source)) {
      this.layer.setSource(new _VectorTile2["default"](Object.assign({
        url: this.props.url,
        format: this.format
      }, this.props.source)));
    } else if (this.props.url !== prevProps.url) {
      this.layer.getSource().setUrl(this.props.url);
    }

    if (this.props.layerStyle !== prevProps.layerStyle) {
      this.layer.setStyle(this.props.layerStyle);
    }
  }
});
var _default = VectorTileLayer;
exports["default"] = _default;